<template>
  <div class="register-of-payments">
    <div class="container">
      <breadcrumb v-if="!isMobile" crumb="table-of-payments" />
      <table-of-payments-toolbar
        :show-table-payments-menu="multipleSelection.length > 0"
        @setDialog="setDialogMenuPayment"
        @searchTablePayments="searchTablePayments"
      />
    </div>
    <div class="register-of-payments__table-container">
      <el-table
        v-loading="isLoading"
        :data="tableData"
        style="width: 100%"
        :span-method="arraySpanMethod"
        class="registry-table"
        row-key="id"
        border
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column width="40" :type="'selection'" />

        <template v-for="col in config">
          <el-table-column
            :key="col.field"
            :min-width="col.width"
            :type="col.type"
            resizable
          >
            <template slot="header">
              <div :class="!!col.subName && 'fs-10'">
                {{ col.name }}
                <div v-if="col.subName">{{ col.subName }}</div>
              </div>
            </template>
            <template slot-scope="scope">
              <div
                :class="{ pointer: col.action, 'fs-10': true }"
                @click="
                  col.action ? handleOpenModal(col.action, scope.row) : null
                "
              >
                {{ getContentTableCell(col, scope.row) }}
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>

    <div class="container">
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
    </div>
    <download-payment-bank-modal
      :items="multipleSelection"
      :visible-modal-name="visibleModalName"
      @close="setDialogMenuPayment(null)"
    />
    <upload-payment-bank-modal
      :items="multipleSelection"
      :visible-modal-name="visibleModalName"
      @close="setDialogMenuPayment(null)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { paymentsStatus, tableFields } from '@/views/TableOfPayments/constants'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import DownloadPaymentBankModal from '@/views/TableOfPayments/modals/DownloadPaymentBankModal'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import TableOfPaymentsToolbar from '@/views/TableOfPayments/components/TableOfPaymentsToolbar'
import UploadPaymentBankModal from '@/views/TableOfPayments/modals/UploadPaymentBankModal'

export default {
  name: 'RegisterOfPayments',
  components: {
    PaginationCustom,
    Breadcrumb,
    TableOfPaymentsToolbar,
    DownloadPaymentBankModal,
    UploadPaymentBankModal,
  },
  data() {
    return {
      config: tableFields,
      visibleModalName: null,
      page: 1,
      search: {},
      multipleSelection: [],
    }
  },
  computed: {
    ...mapGetters({
      tableData: 'tableOfPayments/getPaymentsData',
      pagination: 'tableOfPayments/getPaymentsPagination',
      isLoading: 'tableOfPayments/getLoading',
    }),
  },
  created() {
    this.fetchItems()
  },
  methods: {
    ...mapActions('tableOfPayments', ['fetchPaymentsData']),

    setDialogMenuPayment(type) {
      this.visibleModalName = type
    },
    arraySpanMethod({ row, columnIndex }) {
      if (row.children) {
        return columnIndex === 1 ? [1, 28] : [0, 0]
      }
    },
    tableRowClassName({ row }) {
      return row.children ? 'group-title' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getContentTableCell(col, row) {
      if (col.field === 'payment_status') {
        let status = row[col.field]

        return paymentsStatus[status]
      }
      if (col.field === 'payment_status') {
        return row[col.field] === 0 ? 'Не оплаченно' : 'Оплаченно'
      }

      return row[col.field] === null ? ' - ' : row[col.field]
    },
    handleOpenModal(action, row) {
      this.$alert(row.comment, 'Комментарий: ', {
        confirmButtonText: 'Закрыть',
      })
    },
    changePage(page) {
      this.page = page
      this.fetchItems()
    },
    searchTablePayments(search) {
      this.search = { ...search }
      this.fetchItems()
    },
    fetchItems() {
      this.fetchPaymentsData({
        page: this.page,
        'per-page': 50,
        ...this.search,
      })
    },
  },
}
</script>

<style lang="sass">
@import "~@/assets/styles/mixins.sass"

.register-of-payments
  font-size: 14px
  color: #000
  .btn-group
    display: flex
    align-items: center
  .toolbar
    margin-bottom: 20px
  .registry-table
    &.el-table
      border-bottom: 1px solid #000 !important
      border-right: 1px solid #000 !important
      border-left: 1px solid #000 !important
      border-top: 1px solid #000 !important
      overflow: visible
      min-height: auto
      .el-table__body-wrapper
        padding-bottom: 30px
      .el-table__body
        border-bottom: 1px solid #000 !important
      .el-table__placeholder, .el-table__indent
        display: none
      td, th
        padding: 0
        border-bottom: 1px solid #000 !important
        border-left: 1px solid #000 !important
        &:first-of-type
          border-left: none !important
      tr:last-of-type
        td
          border-bottom: none !important
      .cell
        font-size: 12px
        line-height: 1
        color: #000
        padding: 5px
        text-align: center
      td .cell
        white-space: nowrap
      .fs-10
        font-size: 10px
      .group-title .cell
        text-align: left
        font-weight: bold
        padding-left: 20px
        .el-table__expand-icon
          display: none
  &__table-container
    padding: 0 40px
    +to(1510px)
      padding: 0 12px

  .pointer
    cursor: pointer

  .el-table__header-wrapper
    position: sticky
    top: 0
    z-index: 100
</style>
